import { jsonService } from '@/service/uploadJson';
import stripJsonComments from 'strip-json-comments';
import type { FileStats } from '@/service/uploadJson';

export class UploadJson {
  async upload(file: File): Promise<{ message: string } | undefined> {
    try {
      // Validate JSON file
      if (!this.isValidJsonFile(file)) {
        throw new Error('Please select a valid JSON file');
      }

      const base64Data = await this.fileToBase64(file);
      return await jsonService.upload(base64Data);
    } catch (e) {
      console.warn(e);
      throw e;
    }
  }
  
  async delete(): Promise<boolean> {
    try {
      await jsonService.delete();
      return true;
    } catch (e) {
      console.warn(e);
      return false;
    }
  }

  async get(): Promise<{ data: any; fileStats: FileStats } | undefined> {
    try {
      return await jsonService.get();
    } catch (e) {
      console.warn(e);
    }
  }


  private isValidJsonFile(file: File): boolean {
    // Check file extension
    if (!file.name.toLowerCase().endsWith('.json')) {
      return false;
    }
    // Check MIME type
    if (file.type && !file.type.includes('json')) {
      return false;
    }
    return true;
  }

  private async fileToBase64(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => {
        try {
          const result = reader.result as string;

          // Decode base64 content
          const jsonContent = atob(result.split(',')[1]);

          // Remove comments and validate JSON
          const cleaned = stripJsonComments(jsonContent);
          JSON.parse(cleaned); // Validate JSON

          const base64 = btoa(cleaned);

          resolve(`data:application/json;base64,${base64}`);
        } catch (error) {
          reject(new Error('Invalid JSON content'));
        }
      };
      reader.onerror = () => reject(new Error('Failed to read file'));
      reader.readAsDataURL(file);
    });
  }
}